import React from 'react'
function Skills() {
  return (
       <div className='absolute w-screen h-screen p-20 space-y-14 roboto_regular bg-[#d0d0d0]'>
       <div className='relative flex flex-col w-full h-full space-y-14 '>
          <div className='flex flex-row space-x-16'>
          <div className='space-y-4'><h1 className='roboto_thin text-4xl'>Programming Language</h1>
          <h1 className='text-2xl'>C++</h1><svg width="680" height="45" viewBox="0 0 685 48" fill="none" xmlns="http://www.w3.org/2000/svg">
           <g id="loadingbar">
           <rect id="border" x="3" y="3" width="679" height="42" fill="white" stroke="black" stroke-width="6"/>
           <rect id="r1" x="6" y="5" width="8" height="38" fill="rgb(19 78 74 / 0.8)"/>
           </g>
          </svg>
          <h1 className='text-2xl'>HTML</h1><svg width="680" height="45" viewBox="0 0 685 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="loadingbar">
          <rect id="border" x="3" y="3" width="679" height="42" fill="white" stroke="black" stroke-width="6"/>
          <rect id="r2" x="6" y="5" width="8" height="38" fill="rgb(19 78 74 / 0.8)"/>
          </g>
          </svg>
          <h1 className='text-2xl '>Javascript</h1><svg width="680" height="45" viewBox="0 0 685 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="loadingbar">
<rect id="border" x="3" y="3" width="679" height="42" fill="white" stroke="black" stroke-width="6"/>
<rect id="r6" x="6" y="5" width="8" height="38" fill="rgb(19 78 74 / 0.8)"/>
</g>
</svg>
<h1 className='text-2xl'>CSS</h1><svg width="680" height="45" viewBox="0 0 685 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="loadingbar">
<rect id="border" x="3" y="3" width="679" height="42" fill="white" stroke="black" stroke-width="6"/>
<rect id="r5" x="6" y="5" width="8" height="38" fill="rgb(19 78 74 / 0.8)"/>
</g>
</svg>
       </div>
       <div className='space-y-4 text-4xl'><h1 className='roboto_thin'>Design Tools</h1>
       <h1 className='text-2xl'>Figma</h1><svg width="680" height="45" viewBox="0 0 685 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="loadingbar">
<rect id="border" x="3" y="3" width="679" height="42" fill="white" stroke="black" stroke-width="6"/>
<rect id="r11" x="6" y="5" width="8" height="38" fill="rgb(19 78 74 / 0.8)"/>
</g>
</svg><h1 className='text-2xl'>Adobe Illustrator</h1><svg width="680" height="45" viewBox="0 0 685 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="loadingbar">
<rect id="border" x="3" y="3" width="679" height="42" fill="white" stroke="black" stroke-width="6"/>
<rect id="r9" x="6" y="5" width="8" height="38" fill="rgb(19 78 74 / 0.8)"/>
</g>
</svg>
<div className='relative space-y-4 top-[70px]'>
<h1 className='roboto_thin text-4xl'>Backend Technologies</h1>
<h1 className='text-2xl '>Node.js</h1><svg width="680" height="45" viewBox="0 0 685 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="loadingbar">
<rect id="border" x="3" y="3" width="679" height="42" fill="white" stroke="black" stroke-width="6"/>
<rect id="r11" x="6" y="5" width="8" height="38" fill="rgb(19 78 74 / 0.8)"/>
</g>
</svg> 
   
</div>
       </div>
       </div>
       <div className='flex flex-row space-x-16'>
       <div className='space-y-4'><h1 className='roboto_thin text-4xl'>Frameworks</h1>
<h1 className='text-2xl'>React-Js Framework</h1><svg width="680" height="45" viewBox="0 0 685 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="loadingbar">
<rect id="border" x="3" y="3" width="679" height="42" fill="white" stroke="black" stroke-width="6"/>
<rect id="r7" x="6" y="5" width="8" height="38" fill="rgb(19 78 74 / 0.8)"/>
</g>
</svg>
<h1 className='text-2xl'>Tailwind-CSS Framework</h1><svg width="680" height="45" viewBox="0 0 685 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="loadingbar">
<rect id="border" x="3" y="3" width="679" height="42" fill="white" stroke="black" stroke-width="6"/>
<rect id="r8" x="6" y="5" width="8" height="38" fill="rgb(19 78 74 / 0.8)"/>
</g>
</svg>
</div>
       <div className='space-y-4'><h1 className='roboto_thin text-4xl'>Database</h1>
       <h1 className='text-2xl'>MongoDB</h1><svg width="680" height="45" viewBox="0 0 685 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="loadingbar">
<rect id="border" x="3" y="3" width="679" height="42" fill="white" stroke="black" stroke-width="6"/>
<rect id="r3" x="6" y="5" width="8" height="38" fill="rgb(19 78 74 / 0.8)"/>
</g>
</svg>
       </div>

</div>
      </div>
    </div>
  )
}
export default Skills;